export default function CoreCapabilities() {
  const capabilities = [
    {
      icon: 'ri-brain-line',
      title: 'AI 기술 역량',
      items: [
        '머신러닝 · 딥러닝 알고리즘 개발',
        '자연어처리 · 컴퓨터비전 기술',
        'AI 모델 최적화 및 배포',
      ],
    },
    {
      icon: 'ri-database-2-line',
      title: '데이터 처리 역량',
      items: [
        '대용량 데이터 수집 · 가공',
        '데이터 분석 및 시각화',
        '데이터 파이프라인 구축',
      ],
    },
    {
      icon: 'ri-code-box-line',
      title: '시스템 개발 역량',
      items: [
        '클라우드 기반 시스템 설계',
        '마이크로서비스 아키텍처',
        'DevOps · CI/CD 자동화',
      ],
    },
    {
      icon: 'ri-shield-check-line',
      title: '프로젝트 관리 역량',
      items: [
        '애자일 방법론 기반 개발',
        '품질 관리 및 테스트',
        '운영 · 유지보수 지원',
      ],
    },
  ];

  return (
    <section className="py-36 bg-[#F0FDFA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20 text-center">
          <span className="text-sm font-medium text-[#0F766E] mb-3 block">핵심 역량</span>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Core Capabilities
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-10 border border-[#99F6E4]/30"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-6">
                <i className={`${capability.icon} text-3xl text-[#0D9488]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">{capability.title}</h3>
              <ul className="space-y-3">
                {capability.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-3 mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-xs text-[#0D9488]"></i>
                    </div>
                    <span className="text-sm text-gray-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
